import Typography from 'typography';
import theme from 'typography-theme-st-annes';

theme.bodyColor = '#334C61';
theme.headerColor = '#334C61';
theme.baseFontSize = '16px';
theme.headerFontFamily = ['Source Serif Pro', 'serif'];
theme.scaleRatio = 1.75;
// google fonts are linked manually from layouts/index.js
// coz typography.js doesn’t support subsetting
theme.googleFonts = [];
theme.overrideThemeStyles = (rhythm, options, styles) => ({
  '.articles h2': {
    fontSize: styles.h1.fontSize,
  },
});

const typography = new Typography(theme);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js